const { ValidationError } = require('@plastiq/external-api-errors')

const BaseValidator = require('./BaseValidator')

class ObjectValidator {
  static validate(argument, argumentName) {
    BaseValidator.guardAgainstNullOrUndefined(argument, argumentName)
    BaseValidator.guardAgainstIncorrectTypes(argument, argumentName, 'object')
    validatePopulatedObject(argument, argumentName)
  }
}

function validatePopulatedObject(argument, argumentName) {
  if (Object.keys(argument).length === 0) {
    throw new ValidationError(`Empty object: ${argumentName}`)
  }
}

module.exports = ObjectValidator
